import React, { useCallback, useState } from 'react';
import axios from '../modules/api';
import http from '../modules/api';
import {Line} from 'react-chartjs-2';
import { NavLink, Link, Prompt } from 'react-router-dom';
import $ from 'jquery';
import Slider from "react-slick";
import plus_img from '../../resources/img/plus.svg';
import Pagination from "react-js-pagination";

import GA4React from "ga-4-react";

try {
    setTimeout(_ => {
      const ga4react = new GA4React("G-EBVEYNW6SX");
      ga4react.initialize().catch(err => console.error("ga4react"+err));
    }, 4000);
} catch (err) {
    console.error("ga4react",err);
}

var is_product_loaded = false;

export class KdealProductListForUser extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            // 무료 체험 기간 관련 변수
            remain_date: "",
            start_day_of_week: "",
            start_date_format: "",
            is_finish: "",
            end_day_of_week: "",
            end_date_format: "",

            list : [], // 진열 목록
            all_install_yn : true, // 모든 진열이 설치됐는지에 대한 여부(하나라도 설치되지 않았다면 false)

            /* 페이징 */
            activePage: 1,
			totalCnt: 0,
			startIdx: 0,
			rowcnt:10,

            kdeal_user_no: "",
        }
    }

    componentWillMount() {

    }

	componentDidMount() {
        // $(document).ready(function(){
        //     //table의 넓이 계산
        //     var list_td = document.getElementsByClassName("list_td");
        //     var list_td_sum = 0;
            
        //     for(let i = 0; i < list_td.length; i++){
        //         list_td_sum = list_td_sum + list_td[i].offsetWidth;
        //     }

        //     $(".list_home_main_row_3 table").css({
        //         "width":list_td_sum
        //     });
        // });

        if (sessionStorage.getItem("kdeal_product_list_filter_for_user") != null) {
            let kdeal_product_list_filter = JSON.parse(sessionStorage.getItem("kdeal_product_list_filter_for_user"));
            this.setState({
                activePage: kdeal_product_list_filter.activePage,
                totalCnt: kdeal_product_list_filter.totalCnt,
                startIdx: kdeal_product_list_filter.startIdx,
                rowcnt: kdeal_product_list_filter.rowcnt,
    
                kdeal_user_no: kdeal_product_list_filter.kdeal_user_no,
                keyword: kdeal_product_list_filter.keyword,
            }, () => {
                sessionStorage.removeItem("kdeal_product_list_filter_for_user")
                this.loadKdealProduct(this.state.startIdx, this.state.rowcnt, this.state.keyword, this.state.kdeal_user_no);
                // this.loadKdealShopList();
            })
        } else {
            this.loadKdealProduct(this.state.startIdx, this.state.rowcnt, "", "");
            // this.loadKdealShopList();
        }
        // this.loadFreeDatePeriod();
    }

    componentDidUpdate() {
    }

    componentWillUnmount(e) {

    }

    getUrlParams() {
        var params = {};
        window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) { params[key] = value; });
        return params;
    }

    // setGaEvent(action_text) {
    //     ReactGA.event({
    //          category: "베스트 서비스 (롤링 목록)",
    //          action: action_text,
    //          label: sessionStorage.getItem("user_id"),
    //      });
    // }

    // 소상공인 상품 목록 데이터 불러오기
    async loadKdealProduct(startIdx, rowcnt, keyword, kdeal_user_no) {
        let param = "?";
        param += "&startidx="+startIdx;
        param += "&rowcnt="+rowcnt;
        param += "&keyword="+keyword;
        param += "&kdeal_user_no="+kdeal_user_no;

        // const formData = new FormData();
        // formData.append('startidx',startIdx);
        // formData.append('rowcnt',rowcnt);
        // formData.append('keyword',keyword);
        is_product_loaded = false;

        await http.get("/rest/common/kdeal/product/list"+param)
		.then(res => {
            is_product_loaded = true;
            console.log(res.data);
			if (res.data != null && res.data != '') {
				this.setState({
                    list : res.data["list"],
                    totalCnt : res.data["totalCnt"],
                });
			}
		})
		.catch(error => {
		 });
    }

    // 소상공인 업체 목록 데이터 불러오기
    async loadKdealShopList() {
        await http.get("/rest/common/kdeal/user/list")
		.then(res => {
            console.log(res.data);
			if (res.data != null && res.data != '') {
				this.setState({
                    shop_list : res.data,
                    // totalCnt : res.data["totalCnt"],
                });
			}
		})
		.catch(error => {
		 });
    }

    // 상세 페이지로 이동
    onClickProductPageLink(e, product_no) {
        // 무료 체험 기간에만 이동 가능하도록 변경
        if(this.state.is_finish == 0){
            // this.setGaEvent("목록 클릭 - "+ html_name);
            this.props.history.push(
                {
                    pathname: `/kdeal/common/sosanggongin`,
                    search:`?product_no=`+product_no,
                }	
            )
            sessionStorage.setItem(
                "kdeal_product_list_filter_for_user", 
                JSON.stringify({
                    activePage: this.state.activePage,
                    totalCnt: this.state.totalCnt,
                    startIdx: this.state.startIdx,
                    rowcnt:this.state.rowcnt,
                    kdeal_user_no: this.state.kdeal_user_no,
                    keyword: this.state.keyword
                })
            )
        }
    }

    onClickAddList(e){
        // this.setGaEvent("진열 추가 클릭");
        this.props.history.push(
            {
                pathname: `/kdeal/common/sosanggongin`,
            }	
        )
    }

    // 페이징
	handlePageChange(pageNumber) {
		// console.log(`active page is ${pageNumber}`);
		this.setState({activePage: pageNumber});
		this.state.startIdx = (pageNumber * 10) - this.state.rowcnt;
		// console.log("this.state.startIdx :" + this.state.startIdx )
		this.loadKdealProduct(this.state.startIdx, this.state.rowcnt, this.state.keyword, this.state.kdeal_user_no);
	}  

    // 엔터키 검색
	_handleKeyDown = e => {
        if (e.key === 'Enter') {
            this.state.startIdx = 0;
            this.state.activePage = 1;
            this.loadKdealProduct(this.state.startIdx, this.state.rowcnt, this.state.keyword, this.state.kdeal_user_no);
        }
    }


    render() {
        return (
            <>
                {/* <div id='page-wrapper' className="container" style={{backgroundColor: '#ffffff', minHeight:"100%"}}>
                    <div id="list_wrap" style={{ justifyContent: "start", alignItems: "start"}}> */}
                        <div className="list_home_main" style={{width:"100vw", height:"60px",boxShadow:"rgb(0 0 0 / 5%) 0px 4px 15px"}}>
                            <div style={{height:"100%", display:"flex", alignItems:"center"}}>
                                <a href="/kdeal/shop/product/list">
                                    <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/kdeal_logo.svg" alt="" style={{width:"100%",marginLeft: "-10px;"}}/>
                                </a>
                                <div style={{
                                    marginLeft:"24px",
                                    fontWeight: "500",
                                    fontSize: "18px",
                                    lineHeight: "26px"
                                }}>
                                    <a href="/kdeal/common/product/list" style={{color:"#202020"}}> 소상공인 자료 등록 현황 </a>
                                </div>
                            </div>
                        </div>    
                        <section className="list_home_main">
                            <div className="list_home_main_row_1" style={{display:'flex', justifyContent:"space-between", width: "1200px",maxWidth: "100%"}}>
                                <div className="mobile_margin_bottom_30px" style={{display:'flex'}}>
                                    <h2 className="text_medium" style={{
                                            alignContent: "center",
                                            display: "flex",
                                            marginBottom: 0
                                    }}>소상공인 상세디자인 등록현황</h2>
                                    <div style={{
                                            alignContent: "center",
                                            display: "flex"
                                    }}>
                                        {/* <button className="list_btn_1 hover_lightmint" onClick={e => this.onClickUserGuide(e)}>사용자 가이드</button> */}
                                        <button className="list_btn_1 hover_mint" onClick={e => this.onClickAddList(e)} style={{width: "auto",padding: "0 12px"}}>
                                            <img src={plus_img} alt="더하기 아이콘"/>상세디자인등록
                                        </button>
                                    </div>
                                </div>
                                <div className="mobile-width-100"
                                        style={{
                                            position:"relative", width:"250px", height:"auto", display:"flex", alignItems: "center",alignContent: "center",
                                        }}>
                                        <div class="btn_search" style={{
                                            position: "absolute",
                                            left: "20px",
                                            top: "12px",
                                        }}></div>
                                        <input type="text" value={this.state.keyword}
                                        onChange={(e) => {
                                            // console.log(e.target.value)
                                            this.setState({ keyword: e.target.value })
                                        }} placeholder="자료를 검색해 보세요." style={{width:"100%", height: "42px", padding: "0px 20px 0px 53px"}} onKeyDown={this._handleKeyDown}></input>
                                        {/* <button className = "greenButton" onClick={this.onClickSearchListButton} style={{width: "45px",height: "35px", margin: 'auto'}}>검색</button> */}
                                </div>    
                            </div>
                            <div className="list_home_main_row_3" style={{width: "1200px",maxWidth: "100%"}}>
                                <table style={{width: "100%"}}>
                                    <thead>
                                        <tr>
                                            <td className="list_td" style={{width: "80px"}}>번호</td>
                                            <td className="list_td" style={{width: "260px"}}>업체명 (작성자)</td>
                                            <td className="list_td" style={{width: "auto"}}>상품명 (상세디자인명)</td>
                                            <td className="list_td" style={{width: "200px"}}>작성일시</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { this.state.list != null && this.state.list.length > 0
                                        ?   <>
                                            {
                                                this.state.list.map((obj, idx) => (
                                                    <tr>
                                                        <td onClick={e => this.onClickProductPageLink(e, obj.product_no)}>{(this.state.totalCnt-(idx+(10*(this.state.activePage-1))))}</td>
                                                        <td onClick={e => this.onClickProductPageLink(e, obj.product_no)}>{obj.corp_name}</td>
                                                        <td onClick={e => this.onClickProductPageLink(e, obj.product_no)}>{obj.product_name}</td>
                                                        <td onClick={e => this.onClickProductPageLink(e, obj.product_no)}>{obj.reg_date}</td>
                                                    </tr>
                                                ))
                                            }
                                            </>
                                        :
                                            <div style={{width:"1199px", maxWidth: "100vw"}}>
                                                {
                                                    is_product_loaded == true
                                                    ? "자료가 없습니다."
                                                    : "자료를 불러오는 중입니다."
                                                }
                                            </div>
                                        }
                                    </tbody>
                                </table>
                                <div style={{margin:"15px 0 15px 0", width:"100%"}}>
                                    {
                                        Number(this.state.totalCnt) <= 0
                                        ?   ""
                                        :   <Pagination
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={this.state.rowcnt}
                                                totalItemsCount={this.state.totalCnt}
                                                pageRangeDisplayed={5}
                                                onChange={this.handlePageChange.bind(this)}
                                            />
                                    }
                                </div>
                            </div>
                        </section>
                    {/* </div>
                </div> */}
            </>
        )
    };
    
}